module.exports = __webpack_public_path__ + "static/media/Longest-LongerTerm-Icon.648b86c2.svg";